import { createWithEqualityFn } from 'zustand/traditional'

import { useProfileStore as ProfileStore } from './Profile'

interface CertificateStore {
	data: any[]
	setData: (data: any[]) => void
	getAll: () => Promise<{ success: boolean; data: any }>
}

export const API_SLUG = '/suppliers/certificates'

export const useCertificateStore = createWithEqualityFn<CertificateStore>(
	set => ({
		data: [],
		setData: (data: any[]) => set({ data }),
		getAll: async () => {
			try {
				const certificates = ProfileStore.getState().profile?.supplierCertificates
				if (certificates) {
					set({ data: certificates })
					return { success: true, data: certificates }
				} else {
					return {
						success: false,
						data: 'No certificates found',
					}
				}
			} catch (err: any) {
				return {
					success: false,
					data: err?.response?.data?.message?.toString(),
				}
			}
		},
	}),
	Object.is
)
